import { Column } from 'react-table';
import React from 'react';
import { ColumnFactory } from 'components/data-table/ColumnFactory';

export const constantColumn = (value: string, name: string): Column => {
    const cell = () => (
        <div>{value}</div>
    );
    return ColumnFactory.getColumnOptions(name, name, cell);
};